import {
  branch,
  compose,
  renderComponent,
  withHandlers,
  withProps,
  withState,
} from 'recompose';
import { connect } from 'react-redux';
import { canShowNoOfferView, getActiveLoansList, isInitialLoansLoadDone } from '../selectors';
import { LOANS_FILTER } from '../constants';
import Spinner from '../../common/Spinner';
import NoOfferView from '../NoOffer';

export default compose(
  connect(
    state => ({
      allLoans: getActiveLoansList(state),
      loansLoaded: isInitialLoansLoadDone(state),
      showNoOfferView: canShowNoOfferView(state),
    }),
  ),
  branch(
    props => !props.loansLoaded,
    renderComponent(Spinner),
  ),
  branch(
    props => props.showNoOfferView,
    renderComponent(NoOfferView),
  ),
  withState('filter', 'setFilter', LOANS_FILTER.ALL),
  withProps(props => ({
    filteredLoans: props.filter === LOANS_FILTER.ALL
      ? props.allLoans
      : props.allLoans.filter(loan => props.filter.includes(loan.status)),
  })),
  withHandlers({
    selectFilter: props => newFilter => () => {
      if (props.filter === newFilter) {
        return;
      }

      props.setFilter(newFilter);
    },
  }),
);
